export default "__VITE_ASSET__Dbl7TCpR__"